import { ContactType } from '../enums/contact-type.enum';
import { InformationToSend } from './information-to-send.model';

export class Recipient {
    constructor(
        public id?: string,
        public code?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public isReadOnly?: boolean,
        public invoice?: boolean,
        public analyticalReport?: boolean,
        public analyticalReportCopy?: boolean,
        public contactType?: ContactType,
        public informationToSend?: InformationToSend[],
        public typeOfDocument?: string[],
        public middleName?: string) { }
}
